export default "__VITE_ASSET__DtjfD$yC__"